/**
 * Enum to determine type of costing for a product
 */
export enum ESolutionProductCost {
  Free = 'Free',
  Paid = 'Paid'
}
